module.exports = __webpack_public_path__ + "media/images/athletes/2132-b0e17af42766a962ac03d108e9c475af.png";